import { Box, Typography } from "@mui/material";

type Props = {
  currentBlock: any;
};

const SubTitleFieldPreview = ({ currentBlock }: Props) => {
  const label = currentBlock?.label;

  return (
    <Box sx={{ textAlign: "center" }}>
      <Typography
        variant="body1"
        sx={{
          fontWeight: "medium",
          color: "text.primary",
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};
export default SubTitleFieldPreview;
